import { render, staticRenderFns } from "./LocalisationDestinationCard.vue?vue&type=template&id=e2b8ddb0&"
import script from "./LocalisationDestinationCard.vue?vue&type=script&lang=ts&"
export * from "./LocalisationDestinationCard.vue?vue&type=script&lang=ts&"
import style0 from "./LocalisationDestinationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports